import React from "react";
import styles from "./astrologycommunity.module.css";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Image from "next/image";

import block1 from "../../public/image/astrology-community/astrology_community_blck1_img.webp";
import block2 from "../../public/image/astrology-community/astrology_community_blck2_nw_img.webp";
import block3 from "../../public/image/astrology-community/astrology_community_blck3_img.webp";
import block4 from "../../public/image/astrology-community/astrology_community_blck4_img.webp";
import block5 from "../../public/image/astrology-community/astrology_community_blck5_img.webp";
import block6 from "../../public/image/astrology-community/astrology_community_blck6_img.webp";

import block7Part1 from "../../public/image/astrology-community/astrology_community_blck7_part1_img.webp";
import block7Part2Left from "../../public/image/astrology-community/astrology_community_blck7_part2_left_img.webp";
import block7Part2Right from "../../public/image/astrology-community/astrology_community_blck7_part2_right_img.webp";
import block7Part3 from "../../public/image/astrology-community/astrology_community_blck7_part3_nw_img.webp";

import block8 from "../../public/image/astrology-community/astrology_community_blck8_img.webp";

import courses from "../../public/image/astrology-community/courses_icon.webp";
import studyGroups from "../../public/image/astrology-community/study_groups_icon.webp";
import ritualObservances from "../../public/image/astrology-community/ritual_observances_icon.webp";
import sacredInitiations from "../../public/image/astrology-community/sacred_initiations_icon.webp";
import communityCeremonies from "../../public/image/astrology-community/community_ceremonies_icon.webp";

import block10 from "../../public/image/astrology-community/astrology_community_blck10_img.webp";
import Head from "next/head";
import { useRouter } from "next/router";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";


function Index() {
  const handleOpen = () => setOpen(true);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
    const router = useRouter();

  return (
    <>


    <Head>
    <title>Join Our Astrology Community | Perennial Mandalan Path | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Astrology Community, Perennial Mandalan, Spiritual Astrology, Universal Path, Children of the Stars, Celestial Wisdom, Learn Astrology, Divine Infinite Being"
    ></meta>
    <meta
      property="og:title"
      content="Find Your Cosmic Family: Join the Perennial Mandalan Astrology Community"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/divineinfinitebeing_astrology_community_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A diverse group of people, representing a spiritual community, looking up at a starry sky with a glowing zodiac wheel, symbolizing a shared connection to astrology."
    ></meta>
    <meta
      property="og:description"
      content="Join the Perennial Mandalan Community, a spiritual home for those who see astrology as a living universal path. Connect with like-minded souls, learn the sacred language of the stars, and find your place in the cosmos."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/astrology-community"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/divineinfinitebeing_astrology_community_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A diverse group of people, representing a spiritual community, looking up at a starry sky with a glowing zodiac wheel, symbolizing a shared connection to astrology."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/astrology-community"
    ></meta>
    <meta
      name="twitter:title"
      content="Find Your Cosmic Family: Join the Perennial Mandalan Astrology Community"
    ></meta>
    <meta
      name="twitter:description"
      content="Join the Perennial Mandalan Community, a spiritual home for those who see astrology as a living universal path. Connect with like-minded souls, learn the sacred language of the stars, and find your place in the cosmos."
    ></meta>

    <link rel="canonical" href="https://www.divineinfinitebeing.com/astrology-community" />
</Head>
      <div className={styles.astrology_community_page_main}>
        {/* {/ <!------Main Banner section-------> /} */}
        <div className={styles.perennial_mandalism_blockone}>
          <div className={styles.perennial_mandalism_banner_main_wrpr}>
            <div className={styles.perennial_mandalism_banner_left}>
              <div className={styles.bannerLogo}>
                <span className={styles.logoviewlink} onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                  />
                </span>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                />
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${styles.perennial_mandalism_bottombannerbg} ${styles.bannerboxtxt}`}
              >
                <div className={styles.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <MysteryBannerNew />

        <div className={styles.astrology_community_page_blck_section_main}>
          <div class={styles.common_width}>
            <div className={styles.orange_heading_section}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>
                      Join the Perennial Mandalan Community: Astrology as Our
                      Living Universal Path
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.all_blck_main}>
            <div className={styles.blck_sec_common_width}>
              <div
                className={`${styles.blck1_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  {/* <img src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/astrology_community/astrology_community_blck1_img.webp" /> */}
                  <Image src={block1} alt="Block-1" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_heading}>
                    <h3>
                      <span>A Community</span> for the Children of the Stars
                    </h3>
                  </div>
                  <div className={styles.content_section}>
                    <p>
                      Astrology is far more than a technique, a forecast, or a
                      passing curiosity. It is the universal language of
                      belonging, a bridge between souls that reminds us we are
                      woven together in the cosmic tapestry. Throughout history,
                      those who have turned their eyes to the heavens have
                      discovered an immediate sense of connection — not only to
                      the infinite, but to each other.
                    </p>

                    <p>
                      In a world divided by so many labels, astrology stands
                      apart as a binding force. Whether you call yourself a
                      Christian mystic, a Kabbalist, a Vedic seeker, a Taoist, a
                      ceremonial magician, theurgist, witch, or simply a lover
                      of the night sky, the language of the stars crosses every
                      boundary. It unites us through wonder, through meaning,
                      and through the shared conviction that our lives
                      participate in a greater pattern.
                    </p>

                    <p>
                      Yet in modern times, too many who honor astrology find
                      themselves alone — practicing in silence, or hiding their
                      beliefs from those who might dismiss or ridicule them. The
                      truth is that astrology deserves far more than isolation:
                      it deserves a home, a community, a spiritual family that
                      uplifts, supports, and celebrates its living wisdom.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.astrology_community_banner_wrapper}>
              <div className={styles.astrology_community_banner_innerwrapper}>
                <h2>Deepen your practice beyond the Five-Fold Path and join as a 
                    Perennial Mandalin— connect with fellow seekers, discover celestial 
                    insights, and share this wisdom with your family.
                </h2>
                <Button onClick={() => router.push("/perennial-mandalism")}>read the Five Fold Creed of the Perennial Mandalin</Button>
              </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck2_main}`}>
                <div className={styles.image_section}>
                  <Image src={block2} alt="Block-2" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      We believe astrology also merits a mission — a sacred
                      calling to carry its light to others, much like Christian
                      missionaries have carried their message across the world
                      for centuries. Astrology has the power to awaken hearts,
                      heal wounds, and reconnect souls to their divine pattern,
                      and it should be shared boldly and compassionately.
                      Through teaching, service, and outreach, we can spread
                      this celestial wisdom to all who long for meaning and
                      harmony, building a legacy of understanding and universal
                      connection that reaches beyond a single generation.
                    </p>

                    <p>
                      The Perennial Mandalan stands as that mission-driven
                      community: a place of belonging, a center of learning, and
                      a movement devoted to sharing the living language of the
                      stars with the world. Here, individuals and families can
                      live within the ethos of an astrological spiritual faith,
                      supported by others who cherish the cosmic rhythms. Here,
                      astrology finds not only shelter, but a powerful voice —
                      carried forward, honored, and offered to all who wish to
                      remember their true place in the universe.
                    </p>

                    <p>
                      That is precisely why we have built the Perennial Mandalan
                      community. Our faith is founded on the ethos of astrology
                      as a sacred bridge between all people and all paths,
                      guided by the archetypes of the cosmos. We offer not just
                      instruction, but true community — opportunities for
                      individuals, couples, and families to live within the
                      rhythms of an astrological spiritual tradition.
                    </p>

                    <p>
                      Here, you will find a place where the turning of the
                      seasons, the dance of the planets, and the language of the
                      stars are honored and celebrated. Where your children can
                      grow up understanding their relationship to the sky. Where
                      your personal spiritual path — no matter how unique — is
                      welcomed within the universal pattern of our Divine
                      Infinite Being
                    </p>

                    <p>
                      The world has always needed a sanctuary for those guided
                      by the heavens. Today, that sanctuary is here. Together,
                      as children of the stars, we invite you to join us and
                      bring astrology home.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck3_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block3} alt="Block-3" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_heading}>
                    <h3>
                      <span>Astrology:</span> The Enduring Sacred Language of
                      Humanity
                    </h3>
                  </div>
                  <div className={styles.content_section}>
                    <p>
                      From the dawn of civilization, human beings have looked to
                      the heavens for meaning, pattern, and guidance. This
                      practice — the observation of the stars and their
                      movements, and their symbolic connection to human life —
                      is known as astrology. Its survival over more than 5,000
                      years is not accidental: astrology meets a profound and
                      perennial human need to see ourselves as part of a greater
                      cosmic order.
                    </p>

                    <p>
                      Astrology has thrived through the rise and fall of
                      empires, the crossing of continents, and the revolutions
                      of science and culture. Its language of symbols has
                      adapted, evolved, and survived because it speaks directly
                      to our archetypal, mythic consciousness — the same
                      consciousness your soul resonates with when you look up at
                      the night sky and sense something larger than yourself.
                    </p>

                    <p>
                      In the United States, a 2017 Pew Research Center report
                      revealed that{" "}
                      <strong>29% of Americans believe in astrology,</strong> a
                      striking number for a nation shaped by scientific
                      materialism and rational empiricism. Additional polling by
                      the National Science Foundation found nearly{" "}
                      <strong>40% of Americans under the age of 30</strong> say
                      they view astrology as scientific or at least a valid
                      guidance system, a sign of profound generational change.
                    </p>

                    <p>
                      In India, astrology is not simply a curiosity — it is
                      woven into the daily decision-making of everyday people.
                      According to estimates by the Indian Council of
                      Astrological Sciences,{" "}
                      <strong>over 90% of the Indian population</strong>{" "}
                      consults astrological charts or horoscopes for major life
                      decisions including marriage, business partnerships,
                      childbirth, travel, and religious observances. That means
                      nearly 1.2 billion people integrate astrological wisdom
                      into their culture and lifestyle each year, making India
                      the largest single concentration of active astrological
                      practice on Earth.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck4_main}`}>
                <div className={styles.image_section}>
                  <Image src={block4} alt="Block-4" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      In China, traditional forms of astrology such as the
                      Chinese Zodiac and the Four Pillars of Destiny remain
                      powerful, integrated into celebrations like Lunar New
                      Year, family rituals, matchmaking, and business timing. It
                      is conservatively estimated that over{" "}
                      <strong>800 million Chinese</strong> regularly engage with
                      astrological timing or symbolism in some form.
                    </p>

                    <p>
                      Across Europe, astrology has experienced a marked revival,
                      especially among the younger generations. In countries
                      like France, Italy, and Germany, polling shows that
                      between 20% and 35% of the population expresses confidence
                      in astrological guidance. Among Millennials and Gen Z,
                      astrology is seeing a dramatic resurgence as these
                      generations reclaim spiritual agency beyond the confines
                      of scientific skepticism or rigid religious institutions.
                      In the United Kingdom alone, a 2020 YouGov study found
                      that <strong>over one-third of people under 30</strong>{" "}
                      engage with astrological forecasts at least once per
                      month.
                    </p>

                    <p>
                      Latin America also preserves a powerful astrological
                      tradition, blending indigenous cosmologies with European
                      star lore and Catholic feast days. In Brazil, astrology is
                      so widely practiced that an entire industry of
                      astrologers, readers, and media outlets thrive, reaching
                      tens of millions each year. Mexico shows similar patterns,
                      with astrology woven into the local celebrations of
                      saints, agricultural cycles, and personal relationships.
                    </p>

                    <p>
                      In the Arab world, astrology survived in Sufi mystical
                      orders and among popular folk practices, even when
                      official orthodoxies attempted to marginalize it. From
                      Morocco to the Levant, tens of millions continue to
                      consult horoscopes or astrological calendars, especially
                      for marriage and business planning.
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.blck5_main} ${styles.flex_direction_reverse}`}
              >
                <div className={styles.image_section}>
                  <Image src={block5} alt="Block-5" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <strong>
                        Taken together, conservative global estimates place the
                        number of active astrology believers or practitioners at
                        over 2.5 billion people worldwide,
                      </strong>{" "}
                      nearly a third of the human family. This number includes
                      not only dedicated students of astrological systems, but
                      also those who regularly engage with star signs,
                      horoscopes, or timing systems embedded in their culture.
                    </p>

                    <p>
                      In other words, astrology is not an exotic or fringe
                      tradition — it is one of the most widespread, enduring,
                      and resilient forms of sacred practice the human race has
                      ever known. Its archetypes, symbols, and celestial
                      language have been preserved through centuries of cultural
                      change, colonial disruption, political revolution, and
                      technological upheaval. Today, astrology has adapted and
                      thrived, entering new spaces like social media,
                      psychological counseling, and wellness industries, where
                      its symbols continue to inspire and guide.
                    </p>

                    <p>
                      Astrology’s global renaissance is a testimony to its
                      power: it transcends language, religion, nationality, and
                      social class. Whether in a village in Gujarat, a
                      skyscraper in New York, a café in Berlin, or a festival in
                      São Paulo, people are still looking to the stars to
                      remember who they are and where they belong in the grand
                      pattern of existence.
                    </p>

                    <p>
                      Even in the modern era, global surveys estimate that over{" "}
                      <strong>2 billion people worldwide</strong> in some form
                      consult or hold faith in astrological guidance each year,
                      showing its profound and unbroken relevance.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.blck6_main}`}>
                <div className={styles.image_section}>
                  <Image src={block6} alt="Block-6" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <div className={styles.content_heading}>
                      <h3><span>Astrology in the World’s Spiritual Traditions:</span> A Universal Sacred Science</h3>
                    </div>
                    <p>Astrology has not merely survived — it has flourished, deeply woven into the tapestry of nearly every spiritual tradition humanity has ever known. It stands as one of the great unifying systems of the sacred sciences, transcending language and culture, adapting to new eras while preserving its essential insights. Across the millennia, astrology has served as the common language between the heavens and the human spirit.</p>

                    <h4 className={styles.green_heading}>Christianity and the Christian Mystical Tradition</h4>

                    <p>Although later Christian authorities, particularly after the medieval period, suppressed astrological practices, Christianity’s roots are rich with celestial symbolism. The magi of the Nativity story, honored in Christian tradition, were in fact astrologers guided by their observation of the Star of Bethlehem, using celestial signs to locate the divine presence on Earth.</p>

                    <p>In the early centuries of Christianity, many mystics and theologians regarded the heavens as a sacred “book of God” to be read, an expression of divine order mirroring the harmonies of creation. Medieval Christian scholars — such as Albertus Magnus and Thomas Aquinas — argued that the stars could lawfully signify divine influences, so long as human free will was not denied. Even during the Renaissance, great Christian thinkers like Johannes Kepler practiced astrology alongside their astronomy, seeing no contradiction in seeking God’s language written in the stars.</p>

                    <p>Today, Christian astrology survives in folk customs, Christian mysticism, and in the revival of esoteric traditions which harmonize the planetary spheres with angelic orders and the movements of grace. According to recent surveys, over 27% of American Christians say they see no conflict between their faith and reading horoscopes or astrological symbolism.</p>
                  </div>
                </div>
              </div>

              <div className={styles.block7_main_box}>
                <div className={styles.blck7_part1_main}>
                  <div className={styles.left_content}>
                    <h4 className={styles.green_heading}>Hinduism and Vedic Astrology</h4>

                    <p className={styles.white_cont}>In Hinduism, astrology is not optional — it is a sacred science known as Jyotisha, considered one of the Vedangas, or <strong>“limbs of the Veda.”</strong> Jyotisha guides nearly every significant life choice, from naming ceremonies to marriage, business, and even timing of death rites. Millions of Indian temples have dedicated astrologers who calculate planetary alignments for festivals and sacred timings.</p>

                    <p className={styles.white_cont}>According to research published in The Economic Times, over 90% of Indian families still consult astrologers for major decisions, making Hindu astrology the largest continuous astrological system on the planet, serving the lives of well over a billion people.</p>
                  </div>

                  <div className={styles.image_box}>
                    <Image src={block7Part1} alt="Block-7 Part-1" />
                  </div>

                  <div className={styles.right_content}>
                    <h4 className={styles.green_heading}>Judaism and the Kabbalistic Mysteries</h4>

                    <p className={styles.white_cont}>Astrology’s place in Judaism reaches back to biblical texts that described the firmament as a sign of God’s glory. While rabbinic authorities often debated its role, many Talmudic sages studied planetary influences, and later Jewish mystics — especially Kabbalists — developed sophisticated systems correlating the stars with the sefirot <strong>(emanations of divine light)</strong> and angelic hierarchies.</p>

                    <p className={styles.white_cont}>For example, medieval Jewish astrologers wrote extensively on the roles of Saturn and Jupiter in guiding the fate of Israel, interpreting eclipses, comets, and conjunctions as divine messages. In contemporary Jewish spirituality, astrology continues to be explored in Kabbalistic schools and integrated with Hebrew letter symbolism, and nearly 15% of American Jews, according to Pew Research, report an interest in astrology as part of their spiritual framework.</p>
                  </div>
                </div>

                <div className={`${styles.blck7_part1_main} ${styles.blck7_part2_main}`}>
                  <div className={styles.left_image}>
                    <Image src={block7Part2Left} alt="Blck-7 p-2 Left" />
                  </div>

                  <div className={styles.part2_content}>
                    <h4 className={styles.green_heading}>Platonism and the Western Mystery Schools</h4>

                    <p className={styles.white_cont}>Within the Platonic tradition, astrology held a place of honor as a divine language linking the soul to the cosmos. Plato described the planetary spheres as living intelligences, forming a harmonious architecture of the universe. His followers, especially the Neoplatonists like Plotinus, Iamblichus, and Proclus, regarded the stars as spiritual gateways, echoing the soul’s pre-birth memories and its eventual return to divine unity.</p>

                    <p className={styles.white_cont}>This profound metaphysical framework deeply influenced the Hermetic and Theurgic traditions of late antiquity, where planetary forces were invoked in ritual to align the initiate with the One. Renaissance philosophers like Marsilio Ficino revived these Platonic doctrines, merging Christian and pagan cosmologies with astrological practice — an influence that can still be traced in modern ceremonial magic and occult societies today.</p>
                  </div>

                  <div className={`${styles.left_image} ${styles.right_image}`}>
                    <Image src={block7Part2Right} alt="Blck-7 p-2 Right" />
                  </div>
                </div>

                <div className={`${styles.blck7_part1_main} ${styles.blck7_part3_main}`}>
                  <div className={styles.left_content}>
                    <h4 className={styles.green_heading}>Islam and the Preservation of Astrological Wisdom</h4>

                    <p className={styles.white_cont}>While certain orthodox Islamic scholars criticized astrology as potentially violating divine sovereignty, historically Islam preserved and advanced astrological knowledge during its Golden Age. Astrologers like Al-Biruni, Al-Kindi, and Albumasar were among the most respected scholars in their societies, contributing to both astronomy and astrology while refining complex calculations and planetary models.</p>

                    <p className={styles.white_cont}>Throughout North Africa, Persia, and the Levant, astrology continued in Sufi orders and folk practice, where it helped believers align their prayers and personal destinies with God’s timing. Even today, Islamic cultures preserve popular horoscope traditions around marriage, business, and seasonal activities, with surveys suggesting millions still engage with star-based customs annually.</p>
                  </div>

                  <div className={styles.image_box}>
                    <Image src={block7Part3} alt="Block-7 Part-3" />
                  </div>

                  <div className={styles.right_content}>
                    <h4 className={styles.green_heading}>Taoism and Chinese Astrological Science</h4>

                    <p className={styles.white_cont}>In Taoist cosmology, Chinese astrology represents a profound synthesis of heaven, earth, and humanity. The ancient Chinese astrologers mapped the Heavenly Stems and Earthly Branches, created the 12-year zodiac cycle, and integrated astrological calculations with medical practice, agricultural timing, and imperial governance.</p>

                    <p className={styles.white_cont}>Today, Chinese astrology remains fundamental to celebrations like Lunar New Year, to decisions around marriage, naming, and even the design of buildings. Over 800 million people in China engage regularly with Chinese astrological practices, confirming its place as a living bridge between ancient Taoist philosophy and modern life.</p>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.flex_direction_reverse} ${styles.blck8_main}`}
              >
                <div className={styles.image_section}>
                  <Image src={block8} alt="Block-1" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_heading}>
                    <h3><span>Perennial Mandalan Universalism: </span>A Home for All Who Honor Astrology</h3>
                  </div>
                  <div className={styles.content_section}>
                    <p>Within the Perennial Mandalan faith, we carry forward this legacy by recognizing that astrology is a universal practice that transcends sectarian boundaries. As you see in our own Creed of the Eternal Path, we honor Krishna, Christ, the Tao, the Goddess Devi and the Platonic One — all woven together under our central guiding symbol of the Spherical Mandala of Wholeness.</p>

                    <p>Our Universalist approach holds that no matter your spiritual path — whether you identify as a witch, an occultist, a Christian seeker, a Kabbalist, or simply a religiously curious soul — if astrology calls to you as a guiding principle, then the Perennial Mandalan community is your home. You are invited to celebrate the turning of the seasons, the path of the moon, the dance of the Solar Atman, all within a system that reveres your right to explore and grow.</p>

                    <p>We honor the Anima Mundi, the soul of the world, as the presence of the Holy Spirit. We invoke the gods, goddesses, and divine natures through the Wheel of Astrology and Tarot — these are not dead relics of the past, but the living spiritual technology of our ancestors reborn in a new age.</p>
                  </div>
                </div>
              </div>

              <div className={styles.astrology_community_banner_wrapper}>
              <div className={styles.astrology_community_banner_innerwrapper}>
                <h2>Deepen your practice beyond the Five-Fold Path and join as a 
                    Perennial Mandalin— connect with fellow seekers, discover celestial 
                    insights, and share this wisdom with your family.
                </h2>
                <Button onClick={() => router.push("/perennial-mandalism")}>read the Five Fold Creed of the Perennial Mandalin</Button>
              </div>
              </div>

              <div className={styles.block9_main}>
                <div className={styles.content_heading}>
                  <h3><span>Opportunities</span> to Learn and Grow</h3>
                </div>
                <div className={`${styles.content_section} ${styles.center_align_content}`}>
                  <p>As part of our living community, the Perennial Mandalan faith provides multiple paths for the study and practice of astrology and other forms of divination:</p>
                </div>

                <div className={styles.blck9_main_wrpr}>
                  <div className={styles.blck9_white_box_main}>
                    <div className={styles.icon_section}>
                      <Image src={courses} alt="Courses" />
                    </div>
                    <div className={styles.content_box}>
                      <p><strong>Courses</strong> on astrological techniques for beginners through advanced practitioners</p>
                    </div>
                  </div>

                  <div className={`${styles.blck9_white_box_main} ${styles.violet_box}`}>
                    <div className={styles.icon_section}>
                      <Image src={studyGroups} alt="Study Groups" />
                    </div>
                    <div className={styles.content_box}>
                      <p><strong>Study groups</strong> to explore astrology in Christianity, Hinduism, Platonism, and the Tao</p>
                    </div>
                  </div>

                  <div className={`${styles.blck9_white_box_main} ${styles.light_green_box}`}>
                    <div className={styles.icon_section}>
                      <Image src={ritualObservances} alt="Ritual Observances" />
                    </div>
                    <div className={styles.content_box}>
                      <p><strong>Ritual observances</strong> of solstices, equinoxes, lunar cycles, and planetary alignments</p>
                    </div>
                  </div>

                  <div className={`${styles.blck9_white_box_main} ${styles.blue_box}`}>
                    <div className={styles.icon_section}>
                      <Image src={sacredInitiations} alt="Sacred Initiations" />
                    </div>
                    <div className={styles.content_box}>
                      <p><strong>Sacred initiations</strong> Sacred initiations for those who wish to go deeper into mystery traditions</p>
                    </div>
                  </div>

                  <div className={`${styles.blck9_white_box_main} ${styles.green_box}`}>
                    <div className={styles.icon_section}>
                      <Image src={communityCeremonies} alt="Community Ceremonies" />
                    </div>
                    <div className={styles.content_box}>
                      <p><strong>Community ceremonies</strong> that blend the mythic wisdom of multiple traditions with astrological timing</p>
                    </div>
                  </div>
                </div>

                <div className={styles.content_section}>
                  <p>In our outer order — the public-facing heart of our school — there is no requirement to abandon your personal beliefs. If astrology is your guiding principle, then we welcome you exactly as you are. The path of Our Divine Infinite Being is spacious and universal, capable of holding your witchcraft, your Christian mysticism, your Hermetic studies, or your rational curiosity. All are invited to stand beneath the night sky together, where we remember that we are children of the stars.</p>
                </div>
              </div>

              <div
                className={`${styles.blck1_main} ${styles.flex_direction_reverse} ${styles.blck10_main}`}
              >
                <div className={styles.image_section}>
                  <Image src={block10} alt="Block-10" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_heading}>
                    <h3>A Final <span>Invitation</span></h3>
                  </div>
                  <div className={styles.content_section}>
                    <p>If you have ever felt the mystery of the stars stirring something within you — a sense that there is a pattern, a divine fingerprint, a cosmic intelligence guiding your path — then the Perennial Mandalan community is calling. In an age of confusion, astrology is a timeless beacon, pointing beyond the accidents of culture and history to the One Great Story written in the heavens.</p>

                    <p>Together, through the turning wheel of astrology, we celebrate our union with the Divine Infinite Being, the Spherical Mandala of Wholeness, and the harmony of the Anima Mundi. We stand ready to walk with you — wherever you are on your path — to help you explore, study, and practice astrology as a sacred guide to your own divine unfolding.</p>

                    <p><strong>Join us. Reconnect to the stars. Awaken to the cosmos within. The door is open.</strong></p>
                  </div>
                </div>
              </div>


              <div className={styles.astrology_community_banner_wrapper}>
              <div className={styles.astrology_community_banner_innerwrapper}>
                <h2>Deepen your practice beyond the Five-Fold Path and join as a 
                    Perennial Mandalin— connect with fellow seekers, discover celestial 
                    insights, and share this wisdom with your family.
                </h2>
                <Button onClick={() => router.push("/perennial-mandalism")}>read the Five Fold Creed of the Perennial Mandalin</Button>
              </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="banner_modal_main"
        >
          <Box className="banner_modal_box">
            <Typography
              id="modal-modal-description"
              component="div"
              sx={{ mt: 2 }}
              className="modal_banner"
            >
              <div className="sub_modal_banner">
                <span className="close_btn" onClick={handleClose}>
                  <CloseIcon />
                </span>
                <img
                  src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/assets/images/logobanner.webp"
                  alt="bannerLogo"
                />
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Index;
